import { IJwtMember } from "@/v2/types/Auth/IJwtMember.interface";
import { OWNER_ROLE } from "@/v2/utils/constants";

/**
 * Derives the "active" auth state from the real and impersonated users.
 *
 * The impersonated user takes precedence over the real user, so every consumer
 * reads a single, consistent source of truth: while impersonating, `activeRoles`,
 * `activePermissions` and `isOwner` reflect the impersonated identity; with
 * no impersonation they fall back to the real user.
 */
export const deriveActiveUserState = (
  user?: IJwtMember | null,
  impersonatedUser?: IJwtMember | null,
): {
  activeUser: IJwtMember | null;
  activeRoles: string[];
  activePermissions: string[];
  isOwner: boolean;
} => {
  const activeUser = impersonatedUser ?? user ?? null;
  const activeRoles = activeUser?.roles ?? [];
  const activePermissions = activeUser?.permissions ?? [];

  return {
    activeUser,
    activeRoles,
    activePermissions,
    isOwner: activeRoles.includes(OWNER_ROLE),
  };
};
